import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Tpl_FactMontantGraphComponent, ExempleTemplateComponent, Tpl_MapTemplateComponent, PersonneImageTemplateComponent, ActionCoGraphTemplateComponent} from './';
import { MapModule } from '../../map';



@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgbModule,
    MapModule,
  ],
  declarations: [
    Tpl_FactMontantGraphComponent,
    Tpl_MapTemplateComponent,
    PersonneImageTemplateComponent,
    ExempleTemplateComponent,
    ActionCoGraphTemplateComponent
  ],
  exports: [
   
  ]
})

export class TemplateModule { }
